export const tags = [
  'All',
  'Music',
  'Cricket',
  'Namaste JavaScript',
  'React js',
  'Redux',
  'Frontend Engineer',
  'Coding',
  'Counter-Strike',
  'CSS',
  'HTML',
  'Live',
  'News',
  'football',
  'Web Developer',
  'street food',
  'next js',
  'traversy media',
  'csgo',
  'source 2',
];

//expects a key in the end
export const YOUTUBE_MOST_POPULAR = 'https://youtube.googleapis.com/youtube/v3';

export const BASE_URL = 'https://youtube.googleapis.com/youtube/v3';

export const YOUTUBE_SEARCH_SUGGESTION_API_URL =
  'https://corsproxy.io/?https://clients1.google.com/complete/search?client=firefox&ds=yt&q=http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=';
